import React from 'react';
import "./Loading.css";

const Loader = () => {
    return <div className='loading'>
      <div></div>
  </div>
}

export default Loader
